import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelpersService } from 'src/core/services/helpers.service';

@Component({
  selector: 'app-modal-multi-building',
  templateUrl: './modal-multi-building.component.html',
  styleUrls: ['./modal-multi-building.component.scss']
})

export class ModalMultiBuildingComponent implements OnInit {
  @Input() buildings: any[];
  @Input() end: any;
  @Output() selectBuilding: EventEmitter<any> = new EventEmitter();
  @Output() dismissModal: EventEmitter<any> = new EventEmitter();
  public wait = true;

  constructor(private helpersService: HelpersService) {}

  ngOnInit() {
    if (this.buildings && this.buildings.length) {
      this.wait = this.buildings.length ? false : true;
    }
  }

  public open(buildings) {
    this.buildings = buildings;
    this.helpersService.open('multiBuildingModal');
  }

}
